import {
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  ListContext,
  ListContextValue,
  MenuItemType,
  Stack,
  Typography,
  UpdateButton,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { DataModelInformation, SubmitButton } from "components";
import { DataModelEnum, Form, Permission, PermissionAction, Survey } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const SurveyReportPageHeader = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  reroute: (id: number, crudMode: CrudMode) => void;
  fetch: (id: number) => void;
  fetchRefreshSurvey: (id: number) => void;
  surveyReport: Survey;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.surveyReport.id;

  const save = (surveyReport: Survey) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.surveyReports
        .saveUpdate(surveyReport)
        .then(() => {
          props.reroute(id, "view");
          props.fetch(id);
          props.fetchRefreshSurvey(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.response);
        });
    } else {
      ApiService.surveyReports
        .saveCreate(surveyReport)
        .then((response) => {
          const id = response;
          props.reroute(id, "view");
          props.fetch(id);
          props.fetchRefreshSurvey(id);
          listContext.loadList?.();
          dispatch(setAppToast(newToast("success")));
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.response);
        });
     }
  };

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.surveys.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];

  if (isAuthorized(props.rootPermission, PermissionAction.Delete) && props.crudMode == "edit" && props.surveyReport.id != 0)
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: () => postDelete(id),
    });

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        <Typography variant="inherit">{props.surveyReport.name}</Typography>
        {/* <Typography fontWeight="light">{props.surveyReport.inactive ? "Inactive" : "Active"}</Typography> */}
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <DataModelInformation dataModelType={DataModelEnum.Contributor} dataModelId={id} />
        <CloseButton />
        {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )}
        {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.surveyReport!)} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
